"use strict";

exports.__esModule = true;
exports.GridLayoutIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var GridLayoutIcon = exports.GridLayoutIcon = function GridLayoutIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: props.height,
    viewBox: "0 0 32 32",
    width: props.width
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#515151"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.42 7.221c0-.951-.771-1.721-1.721-1.721h-6.97c-.951 0-1.721.771-1.721 1.721v6.103c0 .951.771 1.721 1.721 1.721H13.7c.951 0 1.721-.771 1.721-1.721V7.221zM27.742 7.221A1.72 1.72 0 0 0 26.021 5.5H19.05c-.951 0-1.721.771-1.721 1.721v6.103c0 .951.77 1.721 1.721 1.721h6.971c.951 0 1.721-.771 1.721-1.721V7.221zM15.42 18.676c0-.951-.771-1.721-1.721-1.721h-6.97a1.72 1.72 0 0 0-1.721 1.721v6.104c0 .95.771 1.721 1.721 1.721H13.7c.951 0 1.721-.771 1.721-1.721v-6.104zM27.742 18.676a1.72 1.72 0 0 0-1.721-1.721H19.05a1.72 1.72 0 0 0-1.721 1.721v6.104c0 .95.77 1.721 1.721 1.721h6.971c.951 0 1.721-.771 1.721-1.721v-6.104z"
  })));
};